module.exports = __webpack_public_path__ + "img/3.bf431df4.svg";